import { render, staticRenderFns } from "./CustomerPrinterDetail.vue?vue&type=template&id=2293f6ac&scoped=true&"
import script from "./CustomerPrinterDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerPrinterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPrinterDetail.vue?vue&type=style&index=0&id=2293f6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293f6ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VRow,VSimpleTable,VSkeletonLoader})
